<script lang="ts">
  import Spinner from '$shared/atoms/Spinner/Spinner.svelte';
  import OptionCell from './OptionCell.svelte';
  import { getFromObject } from '$shared/helpers/utils';
  import TableAlert from '$shared/atoms/TableAlert/TableAlert.svelte';
  import type { AlertAction } from '$shared/models/AlertAction';
  import { Icon } from '$shared/components';

  interface Props {
    row: any;
    columns: ColumnType[];
    alerts?: ObjectType<AlertAction[]>;
    getRowOptions?: any;
    showBanner?: boolean;
    banner?: import('svelte').Snippet;
    onclick?: (payload: any) => void;
    onclickoption?: (payload: { option: CommonList; row: any }) => void;
    onclickAlert?: (payload: any) => void;
    onevent?: (payload: any) => void;
  }

  let {
    row,
    columns,
    alerts = {},
    getRowOptions = () => {},
    showBanner = false,
    banner,
    onclick,
    onclickoption,
    onclickAlert,
    onevent
  }: Props = $props();

  let colLength = $derived(columns.length + 1);

  const onClickRow = (row: any): void => {
    onclick?.(row);
  };

  const onClickOption = (option: CommonList, row: any): void => {
    onclickoption?.({ option, row });
  };
</script>

{#if row}
  <tr
    data-cy="table-row"
    class="table-row"
    onclick={(e) => { e.stopPropagation(); onClickRow(row); }}
    class:hasAlert={alerts && Array.isArray(alerts[row.id]) && alerts[row.id].length !== 0}
  >
    {#each columns as col}
      <td>
        <div class="table-cell">
          {#if col.cellComponent}
            <col.cellComponent {row} column={col} {onevent} />
          {:else}
            {getFromObject(col.id, row) || '--'}
          {/if}
        </div>
      </td>
    {/each}
    <td class="options" width="30px" onclick={(e) => { e.stopPropagation(); }}>
      {#if row.isLoading}
        <div class="spinner-cell">
          <Spinner />
        </div>
      {:else if row.moreActionIcon}
        <div class="action-icon">
          <Icon value={row.moreActionIcon} />
        </div>
      {:else}
        <OptionCell
          list={getRowOptions(row)}
          onclick={(option) => {
            onClickOption(option, row);
          }}
        />
      {/if}
    </td>
  </tr>
  {#if alerts && Array.isArray(alerts[row.id]) && alerts[row.id].length !== 0}
    <tr class="alert-row">
      <td colspan={colLength}>
        <TableAlert alerts={alerts[row.id]} {row} onclickAlert={onclickAlert} />
      </td>
    </tr>
  {/if}

  {#if banner && showBanner}
    <tr>
      <td colspan={colLength}>
        {@render banner?.()}
      </td>
    </tr>
  {/if}
{/if}

<style>
  .table-row:hover {
    cursor: pointer;
    background-color: var(--grey-bg);
  }
  td {
    height: 40px;
    padding-left: 4px;
    padding-right: 4px;
  }
  .table-cell {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    padding-top: 8px;
    padding-bottom: 8px;
    color: var(--grey-dark);
  }
  .alert-row td {
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    padding-bottom: 8px;
  }
  .table-row:not(.hasAlert) td {
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  }
</style>
